import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fdbf09a4"
import script from "./menu.js?vue&type=script&lang=js&external"
export * from "./menu.js?vue&type=script&lang=js&external"
import style0 from "./menu.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports